

export const A_ResponseFeatures = {
    /**
     * Event fired when an error occurs while sending the response
     */
    onError: '_A_Response_onError',
    /**
     * Event fired when the response is closed
     */
    onClose: '_A_Response_onClose',
    /**
     * Event fired when the response is finished
     */
    onFinish: '_A_Response_onFinish',
    /**
     * Event fired when the response is sent
     */
    onSend: '_A_Response_onSend',
    /**
     * Event fired when the response is redirected
     */
    onRedirect: '_A_Response_onRedirect',
} as const;